module.exports = __webpack_public_path__ + "static/img/4.ffb51795.png";